module.exports = __webpack_public_path__ + "img/folder.c24f3d17.svg";